<div>
  @for (keyword of sortedKeywords; track keyword) {
    <span
    class="badge font-size-lg mr-1 mb-1" [ngClass]="isDonor === true ? 'badge-adriatic' : 'badge-indigo'">{{keyword | titleCaseAbbreviation}}</span>
  }
</div>
<div #ref>
  <ng-content></ng-content>
</div>
